import { createTranslations } from '@npco/common-utils-translations'

export const maximumTransactionLimitTranslations = createTranslations({
  header: 'Maximum Transaction Limit',
  description:
    'Transactions made over the set limit will be declined. Max limit is $25,000.00.',
  label: 'Max Transaction Limit',
  ariaLabel: 'max transaction limit',
})
